import axios from "../../config/axiosConfig";
import { getGrayJobReceiveTransactionTakaNo } from './gray-job-receive-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_GRAY_JOB_RECEIVE, GET_GRAY_JOB_RECEIVES, GRAY_JOB_RECEIVE_REQUEST, UPDATE_GRAY_JOB_RECEIVE, DELETE_GRAY_JOB_RECEIVE, GRAY_JOB_RECEIVE_REQUEST_FAILURE } from "../types";

export const getGrayJobReceives = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/gray-job-receive/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GRAY_JOB_RECEIVES, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createGrayJobReceive = (grayJobReceive) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
      const newGrayJobReceive = {
        ...grayJobReceive
      };
      return axios.post("/gray-job-receive/add", newGrayJobReceive,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_GRAY_JOB_RECEIVE, payload: response.data });
          dispatch(getGrayJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_RECEIVE_REQUEST_FAILURE,
            error: "Gray Job Receive create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateGrayJobReceive = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.put("/gray-job-receive/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GRAY_JOB_RECEIVE,
            payload: { id, data: response.data },
          });
          dispatch(getGrayJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: GRAY_JOB_RECEIVE_REQUEST_FAILURE,
            error: "Gray Job Receive update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteGrayJobReceive = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/gray-job-receive/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GRAY_JOB_RECEIVE, id: id });
          dispatch(getGrayJobReceiveTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

// export const printEwayGrayJobReceive = (ewaybillNumber) => {
//   return async (dispatch, getState) => {
//     try {
//       // dispatch({ type: SALES_BILL_REQUEST });
//       console.log("Printing E-Way Bill with number:", ewaybillNumber);
//       const { auth } = getState();
//       let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber };
//       console.log("Params for printing E-Way Bill:", params);
//       return axios.get("/gray-job-receive/print-eway-bill", { params }).then((response) => {
//         return response.data;
//         // if (response.data) {
//         //   dispatch({ type: GET_SALES_BILLS, payload: response.data });
//         // }
//       }).catch((error) => {
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });  
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
//     }
//   };
// };

// export const generateEwayGrayJobReceive = (id) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
//       const { auth } = getState();
//       // let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
//       // console.log('params', params);
//       // let data = {};
      
//       return axios.get(`/gray-job-receive/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
//         if (response.data) {
//           // dispatch({ type: CANCEL_EWAY_BILL, id: id });
//           dispatch({
//             type: UPDATE_GRAY_JOB_RECEIVE,
//             payload: { id, data: response.data },
//           });
//         }
//         return response;
//       }).catch((error) => {
//         console.log('generate eway bill error',error);
        
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });  
//         throw error;
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };

// export const cancelEwayGrayJobReceive = (id, data) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: GRAY_JOB_RECEIVE_REQUEST });
//       const { auth } = getState();
//       return axios.post(`/gray-job-receive/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
//         if (response.data) {
//           dispatch({
//             type: UPDATE_GRAY_JOB_RECEIVE,
//             payload: { id, data: response.data },
//           });
//         }
//         return response;
//       }).catch((error) => {
//         console.error(error);
//         dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });  
//         throw error;
//       });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: GRAY_JOB_RECEIVE_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };